var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/chevronLeft.80850c07.png","uri@2x": __webpack_public_path__ + "static/media/chevronLeft.a5df5281.png","uri@3x": __webpack_public_path__ + "static/media/chevronLeft.c3b9f7d4.png",
    width: 16,
    height: 16
});